import React, { Component } from 'react';

export default class Navigable extends Component {
    nthChild(n){ return this.refs['child-' + n] }
    childCount(){ return quark.get_children(this.props.line).length}
    lastChild(){ return this.nthChild(this.childCount() - 1) }
    parent(){ return this.props.parent }
    root(){
        var cursor = this;
        while(cursor.parent()) cursor = cursor.parent();
        return cursor
    }
    nextSibling(){ return this.parent().nthChild(this.getIndex() + 1, false) }
    prevSibling(){ return this.parent().nthChild(this.getIndex() - 1, false) }
    getIndex(){ return this.props.index }
    next(){
        try {
            var next;
            if(!this.nthChild(0)){
                var current = this;
                while(!current.nextSibling()) current = current.parent();
                next = current.nextSibling()
            }else next = this.nthChild(0);
        } catch (err) { }
        return next
    }
    prev(){
        try {
            var prev;
            if(prev = this.prevSibling()){
                while(prev.nthChild(0)) prev = prev.lastChild();
            }else prev = this.parent();
        } catch (err) {};
        return prev
    }
    focusNext(offset){
        var next = this.next();
        if(next){
            next.focus(true, offset)
            return next
        }
    }
    focusPrev(offset){
        var prev = this.prev();
        if(prev){
            prev.focus(false, offset)
            return prev
        }
    }
    focus(){ console.warn('focus method not implemented') }
}



// WEBPACK FOOTER //
// ./src/react/Navigable.jsx